import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "provider"]
  static values = {
    delay: { type: Number, default: 400 },
    minLength: { type: Number, default: 2 }
  }

  connect() {
    this.timer = null
  }

  disconnect() {
    this.clearTimer()
  }

  schedule() {
    this.clearTimer()
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  submit() {
    const query = this.hasQueryTarget ? this.queryTarget.value.trim() : ""
    const provider = this.hasProviderTarget ? this.providerTarget.value : ""

    if (query.length > 0 && query.length < this.minLengthValue && provider === "") {
      return
    }

    if (this.element.requestSubmit) {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }

  clearTimer() {
    if (!this.timer) return
    clearTimeout(this.timer)
    this.timer = null
  }
}
